export const SUPPORT_BUSINESS_EMAIL = 'support.business-account@21.co';
